disableVideoInfo